export default __webpack_public_path__ + "static/media/(7).18b3ddaf.jpg";